export class CheckV4Item {
	pk: string; //:venueKey
	sk: string; //checkKey_seatKey_item_itemKey

	checkKey: string;

	seatKey: number;

	itemKey: number;

	menuItemKey: number;

	name: string;

	quantity: number;

	price: number;

	position: number;

	level: number;

	priceNumber: number;

	priceNumberName: string;

	prepModCommand: number;

	courseId: number;

	positionId: number;

	discounted: boolean;

	discountAmount: number;

	discountAmountOrderType: number;

	discountInternalId: string;

	void: boolean;

	hold: boolean;

	kitchenComment: boolean;

	sub: boolean;

	extra: boolean;

	no: boolean;

	taxable: boolean;
	externalId: string;

	key: number;

	created: string;

	venueKey: number;

	businessDate: string;

	menuItemKeyBusinessDate: string;

	// businessDateUnix: number;

	// businessDateUnixWithType: string;

	// typeMenuItemKeyBusinessDateUnix;

	public constructor(init?: Partial<CheckV4Item>) {
		Object.assign(this, init);
	}
}
